var $9cc8b85ee8327c05$exports = {};
$9cc8b85ee8327c05$exports = {
  "help": "\u0645\u0633\u0627\u0639\u062F\u0629",
  "info": "\u0645\u0639\u0644\u0648\u0645\u0627\u062A"
};
export { $9cc8b85ee8327c05$exports as default };